import { useToast } from "./ToastContext";
import { useMemo } from "react";

export const useToastHelpers = () => {
  const { showToast } = useToast();

  return useMemo(() => ({
    successToast: (title, description = "") =>
      showToast({ title, description, type: "success" }),

    errorToast: (title, description = "") =>
      showToast({ title, description, type: "error" }),

    warningToast: (title, description = "") =>
      showToast({ title, description, type: "warning" }),

    infoToast: (title, description = "") =>
      showToast({ title, description, type: "info" }),

    successToastTitle: (title) => showToast({ title, type: "success" }),
    errorToastTitle: (title) => showToast({ title, type: "error" }),
    warningToastTitle: (title) => showToast({ title, type: "warning" }),
    infoToastTitle: (title) => showToast({ title, type: "info" }),
  }), [showToast]);
};
